<template>
  <div class="col-cont">
    <div class="col">
      <div class="mbox" v-if="edit_view.step2.summary">
        <div style="float:right; display:flex;">
          <OnOffSlider
            style="margin-left:auto; margin-right:10px;"
            v-if="form.status == 1 || form.status == -1"
            :name="form.id"
            v-model="form.status"
            true_value="1"
            false_value="-1"
            @prop-slider-value-changed="$emit('change-service-status', $event)"
          />
          <a @click="$emit('edit-view-toggle-steps', edit_view.step2)">{{
            T__("EDIT")
          }}</a>
        </div>
        <div class="txt-h4">{{ T__("Event type details") }}</div>
        <div class="form-step-meta">
          <div style="font-size: 14px; padding-top: 10px; margin-bottom:10px;">
            {{ T__("Event type name:") }}
            <span
              class="et-name-edit-view"
              :class="{
                private: saved_form.is_manage_private == 1
              }"
              ><i v-if="saved_form.is_manage_private == 1"></i
              >{{ saved_form.name }}</span
            >
          </div>
          <div style="margin-bottom:10px;">
            {{ T__("Invitee type:") }}
            {{ saved_form.relationship_type | relationship_type_str }}
          </div>
          <div style="padding-bottom:10px; display:flex;">
            {{ T__("Location:") }}
            <span
              style="display: flex; padding: 0 5px;"
              v-if="saved_form.locations.length"
              :inner-html.prop="saved_form.locations | locations_summary"
            ></span>
            <span
              v-if="!saved_form.locations.length"
              style="display: flex; padding: 0 5px;"
            >
              {{ T__("Not set") }}</span
            >
          </div>
          <div style="margin-bottom:10px;">
            {{ T__("Short code:") }}

            <input
              class="shortCode"
              onClick="this.select();"
              type="text"
              spellcheck="false"
              :value="'[wpcal id=' + service_id + ']'"
            />
            <img
              v-if="
                $store.getters.get_admin_details(
                  saved_form.service_admin_user_ids[0]
                ).profile_picture
              "
              :src="
                $store.getters.get_admin_details(
                  saved_form.service_admin_user_ids[0]
                ).profile_picture
              "
              class="serviceEditViewOwnerPic"
              width="30"
              style="border-radius:50%;float:right;"
              :title="
                $store.getters.get_admin_details(
                  saved_form.service_admin_user_ids[0]
                ).display_name
              "
            />
          </div>

          <div>{{ saved_form.descr }}</div>
          <hr />
          <div style="display:flex;">
            <div v-if="saved_form.post_id">
              <a
                :href="'post.php?post=' + saved_form.post_id + '&action=edit'"
                target="_blank"
                >{{ T__("Edit Booking Page") }}
                <span style="font-size:11px; font-weight:600;">&nearr;</span></a
              >
            </div>
            <div
              v-if="saved_form.post_details.link"
              style="margin-left:auto; margin-right: 12px;"
            >
              <a :href="saved_form.post_details.link" target="_blank"
                >{{ T__("View Booking Page") }}
                <span style="font-size:11px; font-weight:600;">&nearr;</span></a
              >
            </div>
          </div>
        </div>
      </div>
      <ServiceFormStep2
        v-if="edit_view.step2.form"
        :$v="$v"
        :view="view"
        :step="{ id: 2, upcoming: false, summary: false, form: true }"
        :form="form"
        :saved_form="saved_form"
        :create_or_update_btn_is_enabled="create_or_update_btn_is_enabled"
        @submit-form="$emit('submit-form', $event)"
        @edit-view-toggle-steps="
          $emit('edit-view-toggle-steps', edit_view.step2)
        "
      ></ServiceFormStep2>

      <div class="mbox" v-if="edit_view.step3.summary">
        <div style="float:right">
          <a @click="$emit('edit-view-toggle-steps', edit_view.step3)">{{
            T__("EDIT")
          }}</a>
        </div>

        <div class="txt-h4">{{ T__("Event type duration &amp; timings") }}</div>
        <div class="form-step-meta mt10">
          <div style="margin-bottom: 10px;">
            {{ T__("Date range:") }}
            {{ service_date_range_summary }}
          </div>
          <div style="margin-bottom: 10px;">
            <div>
              {{ T__("Event duration:") }}
              {{ saved_form.duration | mins_to_str }}
            </div>
            <div>
              {{ T__("Show start times every:") }}
              {{ saved_form.display_start_time_every | mins_to_str }}
            </div>
          </div>

          <div style="text-decoration:underline;">
            {{ T__("Availability for this event type") }}
          </div>
          <div>
            {{ T__("Available hours:") }}
            <div style="display: inline-grid;">
              <div
                v-for="(period, index) in saved_form
                  .default_availability_details.periods"
                :key="index"
              >
                {{ period.from_time | wpcal_format_time_only(time_format) }} -
                {{ period.to_time | wpcal_format_time_only(time_format) }}
              </div>
            </div>
          </div>
          <div style="margin-bottom: 10px;">
            {{ T__("Available days:") }}
            <span>
              {{
                saved_form.default_availability_details.day_index_list
                  | wpcal_format_weekdays_summary
              }}
            </span>
          </div>
          <div style="margin-bottom: 10px;">
            {{ T__("Time zone:") }}
            <span>
              {{ saved_form.timezone | wpcal_format_tz }}
            </span>
          </div>
          <div>
            <div style="text-decoration:underline;">
              {{ T__("Advanced settings") }}
            </div>

            <div>
              {{ T__("Max bookings per day") }}:
              {{
                saved_form.max_booking_per_day
                  ? saved_form.max_booking_per_day
                  : "No limit"
              }}
            </div>
            <div>
              {{ T__("Minimum Scheduling Notice") }}:
              <span v-if="saved_form.min_schedule_notice.type == 'none'">{{
                T__("None")
              }}</span>
              <span v-if="saved_form.min_schedule_notice.type == 'units'">
                {{
                  Tsprintf(
                    /* translators: 1: int 2: mins or hours or days */
                    T__("Prevent booking of slots less than %1$s %2$s away."),
                    this.saved_form.min_schedule_notice.time_units,
                    this.saved_form.min_schedule_notice.time_units_in
                  )
                }}
              </span>
              <span
                v-if="saved_form.min_schedule_notice.type == 'time_days_before'"
              >
                {{
                  Tsprintf(
                    /* translators: 1: time HH:mm 2: int */
                    T_n(
                      "Prevent all bookings after %1$s %2$s day before.",
                      "Prevent all bookings after %1$s %2$s days before.",
                      this.saved_form.min_schedule_notice.days_before
                    ),
                    this.$options.filters.wpcal_format_time_only(
                      this.saved_form.min_schedule_notice.days_before_time,
                      time_format
                    ) + (time_format == "HH:mm" ? " " + T__("hrs") : ""),
                    this.saved_form.min_schedule_notice.days_before
                  )
                }}
              </span>
            </div>
            <div>
              {{ T__("Event buffers") }}:
              <span
                v-if="
                  !saved_form.event_buffer_before &&
                    !saved_form.event_buffer_after
                "
              >
                {{ T__("None") }}
              </span>
              <span v-if="saved_form.event_buffer_before">{{
                Tsprintf(
                  /* translators: 1: int min or int hr int min */
                  T__("%1$s before event"),
                  this.$options.filters.mins_to_str(
                    this.saved_form.event_buffer_before
                  )
                )
              }}</span>
              <span
                v-if="
                  saved_form.event_buffer_before &&
                    saved_form.event_buffer_after
                "
              >
                &amp;
              </span>
              <span v-if="saved_form.event_buffer_after">{{
                Tsprintf(
                  /* translators: 1: int min or int hr int min */
                  T__("%1$s after event"),
                  this.$options.filters.mins_to_str(
                    this.saved_form.event_buffer_after
                  )
                )
              }}</span>
            </div>
          </div>
        </div>

        <button
          style="width: 100%;"
          type="button"
          class="wpc-btn secondary md mt20"
          @click="show_service_availability_modal"
        >
          {{ T__("Set custom hours for specific days/dates") }}
        </button>
        <modal
          name="service_availability_modal"
          :width="'950px'"
          :height="'80%'"
          :adaptive="true"
          @before-close="service_availability_modal_before_close"
          style="z-index:9999;"
        >
          <div class="modal_close_cont">
            <button @click="$modal.hide('service_availability_modal')"></button>
          </div>
          <ServiceAvailabilityCal
            ref="service_availability_modal_contents"
            :timezone="saved_form.timezone"
          />
        </modal>
      </div>

      <ServiceFormStep3
        style="margin-top:20px;"
        v-if="edit_view.step3.form"
        :$v="$v"
        :view="view"
        :step="{ id: 3, upcoming: false, summary: false, form: true }"
        :form="form"
        :create_or_update_btn_is_enabled="create_or_update_btn_is_enabled"
        @submit-form="$emit('submit-form', $event)"
        @edit-view-toggle-steps="
          $emit('edit-view-toggle-steps', edit_view.step3)
        "
        @may-show-service-availability-modal="
          may_show_service_availability_modal
        "
      ></ServiceFormStep3>

      <div class="mbox" v-if="edit_view.step5.summary">
        <div style="float:right; display:flex;">
          <a @click="$emit('edit-view-toggle-steps', edit_view.step5)">{{
            T__("EDIT")
          }}</a>
        </div>
        <div class="txt-h4">
          {{ T__("Event type notification") }}
          <a
            href="https://help.wpcal.io/en/article/what-are-event-type-notification-options-how-does-it-work-how-to-change-it-13cie5k/?utm_source=wpcal_plugin&utm_medium=contextual"
            target="_blank"
            class="icon-q-mark"
          ></a>
        </div>
        <div class="form-step-meta mt10">
          <div style="margin-bottom:5px;">
            {{ T__("Invitee notification type:") }}
            {{
              saved_form.invitee_notify_by == "calendar_invitation"
                ? "Calendar Invitation"
                : "Email"
            }}
          </div>
          <div
            class="txt-help"
            v-if="saved_form.invitee_notify_by == 'calendar_invitation'"
          >
            A calendar invitation will be sent directly from the calendar app
            eg. Google Calendar. If the 'Add bookings to...' calendar is not
            set, it will fallback to email.<a
              href="https://help.wpcal.io/en/article/what-are-event-type-notification-options-how-does-it-work-how-to-change-it-13cie5k/?utm_source=wpcal_plugin&utm_medium=contextual#1-what-are-event-type-notification-options-for-invitee-and-how-does-it-work"
              target="_blank"
              >Learn more</a
            >.
          </div>
          <div class="txt-help" v-if="saved_form.invitee_notify_by == 'email'">
            An email notification with the details of their booking will be sent
            to the invitees.
          </div>
        </div>
      </div>

      <ServiceFormStep5
        style="margin-top:20px;"
        v-if="edit_view.step5.form"
        :$v="$v"
        :view="view"
        :step="{ id: 5, upcoming: false, summary: false, form: true }"
        :form="form"
        :create_or_update_btn_is_enabled="create_or_update_btn_is_enabled"
        @submit-form="$emit('submit-form', $event)"
        @edit-view-toggle-steps="
          $emit('edit-view-toggle-steps', edit_view.step5)
        "
      ></ServiceFormStep5>

      <div class="mbox">
        <div
          class="form-step-meta"
          v-html="
            Tsprintf(
              /* translators: 1: html-tag-open 2: html-tag-close 3: email */
              T__(
                'New booking, rescheduling and cancellation notifications will be sent to %1$s %3$s %2$s (host\'s WP admin email).'
              ),
              '<span style=&quot;color:#131336&quot;>',
              '</span>',
              $store.getters.get_admin_details(
                saved_form.service_admin_user_ids[0]
              ).email
            )
          "
        ></div>
      </div>
    </div>

    <div class="col">
      <div
        style="font-size:16px; font-weight:500; margin: 0px 0 10px; display:flex;"
      >
        {{ T__("Additional Options") }}
        <PremiumInfoBadge
          style="margin: -10px 0 0 10px;"
          highlight_feature="questions"
        >
          <em>Free: 1 question<br />Plus: Unlimited</em>
        </PremiumInfoBadge>
      </div>
      <ServiceInviteeQuestions
        v-model="form.invitee_questions"
        @save-questions="$emit('save-questions', $event)"
      />
    </div>
    <AlertAdminToUpdateProfile
      :service_details="saved_form"
      v-if="saved_form.name"
    />
  </div>
</template>

<script>
import ServiceFormStep2 from "@/components/admin/ServiceFormStep2.vue";
import ServiceFormStep3 from "@/components/admin/ServiceFormStep3.vue";
import ServiceFormStep5 from "@/components/admin/ServiceFormStep5.vue";
import ServiceAvailabilityCal from "@/components/admin/ServiceAvailabilityCal.vue";
import ServiceInviteeQuestions from "@/components/admin/ServiceInviteeQuestions.vue";
import AlertAdminToUpdateProfile from "@/components/admin/AlertAdminToUpdateProfile.vue";
import OnOffSlider from "@/components/form_elements/OnOffSlider.vue";

import { on_before_leave_alert_if_unsaved } from "@/utils/on_before_leave_alert_if_unsaved_mixin.js";

export default {
  name: "ServiceFormEditView",
  mixins: [on_before_leave_alert_if_unsaved("saved_form", "form")],
  components: {
    ServiceFormStep2,
    ServiceFormStep3,
    ServiceFormStep5,
    ServiceAvailabilityCal,
    ServiceInviteeQuestions,
    AlertAdminToUpdateProfile,
    OnOffSlider
  },
  props: {
    view: {
      type: String
    },
    edit_view: {
      type: Object
    },
    form: {
      type: Object,
      required: true
    },
    saved_form: {
      type: Object,
      required: true
    },
    service_id: {},
    create_or_update_btn_is_enabled: {},
    $v: {}
  },
  computed: {
    service_date_range_summary() {
      let default_availability_details = this.saved_form
        .default_availability_details;
      if (default_availability_details.date_range_type === "relative") {
        let misc_value = default_availability_details.date_misc;
        let show_misc_value = misc_value.replace(/^\+((\d)*)D$/gm, function(
          x,
          y
        ) {
          return y;
        });
        return this.Tsprintf(
          /* translators: %s: int */
          this.T__("%s rolling days into the future"),
          show_misc_value
        );
      } else if (default_availability_details.date_range_type == "from_to") {
        let from_date_str = this.$options.filters.wpcal_format_std_date(
          default_availability_details.from_date
        );
        let to_date_str = this.$options.filters.wpcal_format_std_date(
          default_availability_details.to_date
        );
        return this.Tsprintf(
          /* translators: 1: date 2: date */
          this.T__("From %1$s to %2$s"),
          from_date_str,
          to_date_str
        );
      } else if (default_availability_details.date_range_type == "infinite") {
        return this.T__("Indefinitely");
      }
      return "";
    }
  },
  methods: {
    may_show_service_availability_modal() {
      //request comes from step3
      if (this.oblaiu_is_form_dirty()) {
        if (this.oblaiu_confirm_leave(true)) {
          this.form = this.clone_deep(this.saved_form);
          this.$emit("edit-view-toggle-steps", this.edit_view.step3);
          this.$nextTick(() => {
            this.show_service_availability_modal();
          });
        } else {
          return;
        }
      } else {
        this.$emit("edit-view-toggle-steps", this.edit_view.step3);
        this.$nextTick(() => {
          this.show_service_availability_modal();
        });
      }
    },
    show_service_availability_modal() {
      this.$modal.show("service_availability_modal");
    },
    service_availability_modal_before_close(event) {
      let child = this.$refs.service_availability_modal_contents;
      if (child.show_edit_date_availability_popup) {
        child.close_edit_date_availability_popup_by_date();
        event.stop();
      }
    }
  }
};
</script>

<style lang="css" scoped>
.form-step-meta {
  color: #7c7d9c;
}
.form-step-meta .et-name-edit-view.private {
  position: relative;
  padding-left: 15px;
  margin-left: 4px;
}
.form-step-meta .et-name-edit-view.private i {
  position: absolute;
  left: 0;
}
.form-step-meta .et-name-edit-view.private i::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 61.25 78.75'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23131336;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M56.88,26.25H52.5V21.88a21.88,21.88,0,1,0-43.75,0v4.37H4.38A4.38,4.38,0,0,0,0,30.62V74.38a4.38,4.38,0,0,0,4.38,4.37h52.5a4.37,4.37,0,0,0,4.37-4.37V30.62A4.37,4.37,0,0,0,56.88,26.25ZM17.5,21.88a13.13,13.13,0,1,1,26.25,0v4.37H17.5ZM52.5,70H8.75V35H52.5Z'/%3E%3Cpath class='cls-1' d='M30.62,46.11a6.56,6.56,0,1,0,6.57,6.56A6.57,6.57,0,0,0,30.62,46.11Zm0,8.75a2.19,2.19,0,1,1,2.19-2.19A2.19,2.19,0,0,1,30.62,54.86Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 10px;
  height: 13px;
  left: 0;
  opacity: 0.6;
}
.form-step-meta .et-name-edit-view.private i::after {
  content: "Private";
  display: none;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 11px;
  font-style: normal;
  padding: 1px 3px;
  border-radius: 3px;
  position: absolute;
  margin: -22px 0 0 -16px;
}
.form-step-meta .et-name-edit-view.private i:hover::after {
  display: inline-block;
}
input[type="text"].shortCode {
  font-family: monospace !important;
  background-color: rgb(250, 250, 250);
  border: 1px solid rgba(124, 125, 156, 0.4) !important;
  border-radius: 3px !important;
  padding: 8px 0px 12px !important;
  width: 110px !important;
  height: 10px;
  text-align: center;
  font-size: 13px !important;
  min-height: unset;
}
img.serviceEditViewOwnerPic {
  margin-top: -7px;
}
</style>
